import { useSelector } from "react-redux";

import { useMapContext } from "../MapContext";
import MapInformationWindow from "../MapInformationWindow";

const MapPanelsManager = props => {
  const { mapKey } = useMapContext();
  const informationWindowGeometryId = useSelector(
    ({ map }) => map[mapKey]?.informationWindow?.mapElementGeometryId
  );

  const { children } = props;

  return (
    <>
      {/* 
        Render children if there is no information window, and avoid showing when there is
        one, as it creates strange behavior when we close the the information window.
       */}
      {!informationWindowGeometryId && children}

      {informationWindowGeometryId && (
        <MapInformationWindow informationWindowGeometryId={informationWindowGeometryId} />
      )}
    </>
  );
};

export default MapPanelsManager;
